var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M3.417 13.29a7 7 0 0 0 9.872-9.872zM8 1a7 7 0 0 0-5.29 11.582l9.872-9.872A6.97 6.97 0 0 0 8 1",
  clipRule: "evenodd"
})));
export default SvgCancel;